import { render, staticRenderFns } from "./WarmingTrays.vue?vue&type=template&id=540eb2a3"
import script from "./WarmingTrays.vue?vue&type=script&lang=js"
export * from "./WarmingTrays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports